import { API } from '../../../../config'
import { errorHandler } from '../../auth/errorAction'

export const unmountVillageBySubDistrict = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_VILLAGE'})
}

export const villageBySubDistrict = (value) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_VILLAGE' })
  const params = { 
    id: value 
  }
  API.GET('/village/getBySubDistrictId', params).then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_VILLAGE_SUCCESS', 
      payload: {
        data: response.data,
        meta: response.meta
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err.error || err.message, 
      dispatch({ type: 'LOAD_DATA_MASTER_VILLAGE_FAILED' }), 
    ))
  })
}